import { render } from "./AllReports.vue?vue&type=template&id=2e913210"
import script from "./AllReports.vue?vue&type=script&lang=js"
export * from "./AllReports.vue?vue&type=script&lang=js"

import "./AllReports.vue?vue&type=style&index=0&id=2e913210&lang=css"
script.render = render

export default script